export {
  initTelemetry,
  trackError,
  trackEvent,
  setTelemetryUser,
  clearTelemetryUser,
  isTelemetryEnabled,
} from './browserClient';
export type { GsTelemetryConfig } from './browserClient';
export { generateCorrelationId } from './correlationId';
